import React, { useRef, useState } from "react";
import CanvasDraw from "react-canvas-draw";
import { editImage } from "../../actions/UserActions";
import { connect } from "react-redux";
import { Button, Col, Form, Row, Card } from "react-bootstrap";
import imgplaceholder from "../../assets/img/image-placeholder.png";
import imgloaderImage from "../../assets/img/generating.png";

function EditImageai({ editImage }) {
  const canvasRef = useRef();
  const fileInputRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [imageSrc1, setImageSrc1] = useState(null);
  const [brushColor, setBrushColor] = useState("#FFFFFF");
  const [isDrawing, setIsDrawing] = useState(true);
  const [imgNumbers, setImgNumbers] = useState(1);
  const [validation, setValidation] = useState(false);
  const [validationsize, setValidationsize] = useState(false);
  const [size, setSize] = useState("256x256");
  const [imgloader, setImgloader] = useState(false);
  const [prompt, setInputPrompt] = useState("");
  const [generatedImg, setGeneratedImg] = useState([]);
  const [theInputKey, setTheInputKey] = useState("");

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    // console.log("fileee", file);
    setImageSrc1(file);
    const reader = new FileReader();

    reader.onload = (e) => {
      setImageSrc(e.target.result);
    };

    reader.readAsDataURL(file);
  };

  const handleFileInputClick = () => {
    // Trigger the file input's click event
    fileInputRef.current.click();
  };

  const handleClearCanvas = () => {
    if (canvasRef.current) {
      canvasRef.current.clear();
    }
  };

  const handleToggleDrawErase = () => {
    setIsDrawing(!isDrawing);
    // setBrushColor((prevColor) =>
    //   prevColor === "transparent" ? "#000000" : "transparent"
    // );
  };

  //   const handleCaptureImage = () => {
  //     if (canvasRef.current) {
  //       const canvas = canvasRef.current.canvasContainer.children[1];
  //       const imageDataURL = canvas.toDataURL("image/png");
  //       console.log(imageDataURL);

  //       // Now you can send imageDataURL to the API or further process it
  //     }
  //   };

  const handleCaptureImage = () => {
    setImgloader(true);
    const canvas = canvasRef.current.canvasContainer.children[1];
    const editedImageDataURL = canvas.toDataURL("image/png");
    // console.log("editedImageDataURL", editedImageDataURL);

    const editedImage = new Image();
    editedImage.src = editedImageDataURL;

    editedImage.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = editedImage.width;
      canvas.height = editedImage.height;
      const context = canvas.getContext("2d");

      // Draw the original image first
      const originalImage = new Image();
      originalImage.src = imageSrc;

      originalImage.onload = () => {
        context.drawImage(
          originalImage,
          0,
          0,
          editedImage.width,
          editedImage.height
        );

        // Draw the edited image on top
        context.drawImage(editedImage, 10, 5);

        // Convert the combined canvas to a data URL
        const finalBase64 = canvas.toDataURL("image/png").split(",")[1];
        // console.log(finalBase64);
        // Now you can further process or export the edited image

        let formData = new FormData();
        formData.append("imagebuffer", finalBase64);
        formData.append("image", imageSrc1);
        formData.append("prompt", prompt);
        formData.append("imgNumbers", imgNumbers);
        formData.append("size", size);

        editImage(formData).then((res) => {
          if (res.status === 200) {
            setGeneratedImg(res.data.images);
            setImgloader(false);
          } else {
            setImgloader(false);
          }
        });
      };
    };
  };

  const onChangeseletfeild = (e) => {
    setImgNumbers(e);
    if (e != "0") {
      setValidation(false);
    } else {
      setValidation(true);
    }
  };

  const onChangesize = (e) => {
    setSize(e);
    if (e != "0") {
      setValidationsize(false);
    } else {
      setValidationsize(true);
    }
  };

  const handleChange = (value) => {
    if (value == "") {
      setImgloader(false);
    }
    setInputPrompt(value);
  };

  const handleClear = (value) => {
    let randomString = Math.random().toString(36);
    setTheInputKey(randomString);
    setInputPrompt("");
    setImgloader(false);
    setGeneratedImg([]);
  };

  return (
    <div>
      <div className="p-3">
        <input
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          ref={fileInputRef}
          key={theInputKey || ""}
          onChange={handleImageUpload}
        />
        <Button
          onClick={handleFileInputClick}
          variant="primary"
          className="btn-blue w-90 font-14 mr-3 generate-btn"
        >
          Upload Image
        </Button>
        <button
          className="btn-blue w-90 font-14 mr-3 generate-btn btn btn-primary"
          onClick={handleToggleDrawErase}
        >
          {isDrawing ? "Switch to Erase" : "Switch to Draw"}
        </button>
        <button
          className="btn-blue w-90 font-14 mr-3 mt-3 generate-btn btn btn-primary"
          onClick={handleClearCanvas}
        >
          Clear Canvas
        </button>
        {imageSrc && (
          <>
            <div className="brush-images-upload">
              <CanvasDraw
                ref={canvasRef}
                canvasWidth={window.innerWidth}
                canvasHeight={800}
                brushColor={brushColor}
                brushRadius={5}
                disabled={!isDrawing}
                imgSrc={imageSrc}
              />
            </div>

            {validation ? (
              <p style={{ color: "red" }}>please select number of images</p>
            ) : (
              ""
            )}

            <div className="multi-step multi-step-admin">
              <div className="admin-steps admin-content-area">
                <div className="container-custom">
                  <Form className="form-sm form-admin">
                    <Row>
                      <Col md={12}>
                        <Row>
                          {/* <Col xs={12} sm={6}>
                            <Form.Group>
                              <Form.Label>Select an Image</Form.Label>
                              <div>
                                <input
                                  type="file"
                                  id="myfile"
                                  onChange={handleFileChange}
                                  style={{ display: "none" }}
                                  ref={fileInputRef}
                                  name="myfile"
                                  key={theInputKey || ""}
                                />
                                <Button
                                  onClick={handleFileInputClick}
                                  variant="primary"
                                  className="btn-blue w-90 font-14 mr-3 generate-btn"
                                >
                                  Upload Image
                                </Button>

                                <h6>{selectedFile && selectedFile.name}</h6>
                              </div>
                              {validationImagetype ? (
                                <p style={{ color: "red" }}>
                                  Please select a valid image file.
                                </p>
                              ) : (
                                ""
                              )}
                              {apierror ? (
                                <p style={{ color: "red" }}>
                                  AI cannot make variant of this image
                                </p>
                              ) : (
                                ""
                              )}
                            </Form.Group>
                          </Col> */}
                          <Col xs={12} sm={3}>
                            <Form.Group>
                              <Form.Label>Number of Images</Form.Label>

                              <select
                                className="form-control form-control-sm form-control-head"
                                style={{ width: "50%" }}
                                onChange={(e) => {
                                  onChangeseletfeild(e.target.value);
                                }}
                                value={imgNumbers}
                              >
                                <option value="0">
                                  Select number of images
                                </option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                              </select>
                            </Form.Group>
                          </Col>
                          <Col xs={12} sm={3}>
                            <Form.Group>
                              <Form.Label>Size of Image</Form.Label>

                              <select
                                className="form-control form-control-sm form-control-head"
                                style={{ width: "50%" }}
                                onChange={(e) => {
                                  onChangesize(e.target.value);
                                }}
                                value={size}
                              >
                                <option value="0">Select size of image</option>
                                <option value="256x256">256x256</option>
                                <option value="512x512">512x512</option>
                                <option value="1024x1024">1024x1024</option>
                              </select>

                              {validationsize ? (
                                <p style={{ color: "red" }}>
                                  please select size of image
                                </p>
                              ) : (
                                ""
                              )}
                            </Form.Group>
                          </Col>
                          <Col xs={12} sm={6}>
                            <Form.Group>
                              <Form.Label>Edit Text Prompt</Form.Label>
                              <textarea
                                class="form-control"
                                id="textAreaExample2"
                                rows="4"
                                value={prompt}
                                onChange={(e) => {
                                  handleChange(e.target.value);
                                }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="form-group pt-4 pb-4">
                      <Col>
                        <button
                          onClick={handleCaptureImage}
                          disabled={
                            prompt.trim().length === 0 ||
                            validation ||
                            validationsize
                              ? true
                              : false
                          }
                          className="btn-blue w-90 font-14 mr-3 generate-btn btn btn-primary"
                        >
                          Capture Image
                        </button>

                        <Button
                          onClick={handleClear}
                          disabled={prompt.trim().length === 0 ? true : false}
                          className="btn-blue w-90 font-14 mr-3 generate-btn btn btn-primary"
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                  <div>
                    <Row>
                      {imgloader ? (
                        <>
                          <Col xs="12" sm="3">
                            <Card className="transaction-single">
                              <img src={imgloaderImage} alt="no record" />
                            </Card>
                          </Col>
                        </>
                      ) : generatedImg.length > 0 ? (
                        generatedImg.map((singleimg) => {
                          return (
                            <>
                              <Col xs="12" sm="3">
                                <Card className="transaction-single">
                                  <img src={singleimg.url} alt="images" />
                                </Card>
                              </Col>
                            </>
                          );
                        })
                      ) : (
                        <Col xs="12" sm="3">
                          <Card className="transaction-single">
                            <img src={imgplaceholder} alt="no record" />
                          </Card>
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    editImage,
  }
)(EditImageai);
